import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IContainer } from "@models/entity-models";


@Kbo(CToken.Container)
export class Container extends UiObject implements IContainer {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public isPlaceholder: boolean;
    public itemLayout: string;
    public itemAlignment: string;
    public itemJustify: string;
    public spaceBetweenItems: string;
    public scroll: string;
    public padding: string;
    public collapseOnMobile: boolean;
    public backgroundColor: string;
    public backgroundShade: string;
    public backgroundOpacity: number;
    public elevation: string;
    

    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }

    // public visible: boolean;


    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return this.containerChildren(rootType);
    }
}
